<template>
    <transition name="fade">
        <FloatingActionButton
            v-if="shouldShow"
            :id="id"
            class="back-to-top"
            :icon="['fas', 'arrow-up']"
            tooltip-wording="Back to Top"
            type="custom"
            @toggled="scrollToTop"
        />
    </transition>
</template>

<script>
    import {library} from '@fortawesome/fontawesome-svg-core';
    import {faArrowUp} from '@fortawesome/pro-solid-svg-icons';
    import uniqueId from 'lodash/uniqueId';

    import FloatingActionButton from './FloatingActionButton.vue';

    library.add(faArrowUp);

    export default {
        name: 'BackToTop',
        components: {
            FloatingActionButton,
        },
        props: {
            /**
             * Sets the 'id' attribute on the button
             */
            id: {
                type: String,
                default: () => {
                    return uniqueId();
                }
            },
            /**
             * The ID of the element should be scrolled to (default is top of page)
             */
            topElement: {
                type: String,
                // `null`
                default: () => null
            }
        },
        data() {
            return {
                shouldShow: false,
            };
        },
        computed: {
            yCoords() {
                if (this.topElement) {
                    return document.getElementById(this.topElement).getBoundingClientRect().top + (window.pageYOffset || document.documentElement.scrollTop);
                }

                return 0;
            }
        },
        created() {
            window.addEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollToTop() {
                window.scrollTo({
                    top: this.yCoords,
                    behavior: 'smooth'
                });
            },
            handleScroll() {
                this.shouldShow = this.yCoords < (window.pageYOffset - window.innerHeight);
            },
        }
    };
</script>

<style
    lang="sass"
    scoped
>
    .back-to-top
        z-index: 9999
        position: fixed
        right: 5rem
        bottom: 5rem
        height: 2.8125rem
        width: 2.8125rem
        font-size: 1.6rem

    .fade-enter-active, .fade-leave-active
      transition: opacity .2s ease-in-out

    .fade-enter, .fade-leave-to
      opacity: 0
</style>
